
const ReserveRequest = {
	"searchKey": "9bf5b39e-b051-4ad2-b87b-e10fbb505d2b",
   "gdsRefrenceID": "4ad12fe8-e10b-42e5-abee-c69c6217c3b7",
	"travelerInfo": {
		"phoneNumber": "09121234567",
		"email": "mr.test@gmail.com",
		"mobile": "09121234567",
		"airTravelers": [
			{
				"dateOfBirth": "1989-01-10",
				"gender": 1,
				"passengerType": 1,
				"passengerName": {
					"passengerFirstName": "test",
					"passengerMiddleName": "",
					"passengerLastName": "test",
					"passengerTitle": "Mr"
				},
				"passport": {
					"country": null,
					"expiryDate": null,
					"passportNumber": null
				},
				"nationalId": "1534018166",
				"nationality": "IR"
			}
		]
	}
};
   
  
    export default ReserveRequest;
    